'use client';

interface ContactDetail {
  label: string;
  value: string | string[];
  type: 'text' | 'link';
  href?: string;
}

interface ContactDetailsFrenchProps {
  className?: string;
}

const ContactDetailsFrench = ({ className = '' }: ContactDetailsFrenchProps) => {
  const contactInfo: ContactDetail[] = [
    {
      label: "Adresse",
      value: [
        "62 Rue de Caumartin",
        "75009 Paris",
        "France"
      ],
      type: "text"
    },
    {
      label: "Email",
      value: "contact@ndlaw.fr",
      type: "link",
      href: "mailto:contact@ndlaw.fr"
    }
  ];

  return (
    <section className={`py-16 lg:py-24 bg-background ${className}`}>
      <div className="w-full max-w-[1600px] mx-auto px-8 lg:px-16">
        <div className="max-w-4xl mx-auto">
          {/* Modern Card Layout */}
          <div className="bg-surface border border-primary/10 p-10 lg:p-16">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
              {contactInfo.map((item, index) => (
                <div key={index} className="space-y-4">
                  <h3 className="text-xs font-medium tracking-[0.15em] text-text-secondary/60 uppercase">
                    {item.label}
                  </h3>
                  {item.type === 'link' && item.href ? (
                    <a 
                      href={item.href}
                      className="block text-lg lg:text-xl text-primary font-light hover:text-primary/70 transition-colors duration-200"
                    >
                      {item.value}
                    </a>
                  ) : (
                    <div className="text-lg lg:text-xl text-primary font-light leading-relaxed">
                      {Array.isArray(item.value) ? (
                        item.value.map((line, lineIndex) => (
                          <p key={lineIndex}>{line}</p>
                        ))
                      ) : (
                        <p>{item.value}</p>
                      )}
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Confidentiality Note */}
            <div className="mt-12 pt-8 border-t border-primary/10">
              <p className="text-sm text-text-secondary/70 font-light leading-relaxed text-justify">
                Toutes les demandes sont traitées avec la plus grande discrétion et confidentialité.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactDetailsFrench;